import React from 'react';
import { Icon, Spinner } from 'ui';

const IlosRecording = props => {
  const { token, errorMessage, unloadWebcam, recording, i18n } = props;

  return (
    <div className="IlosVideoEmbed-webcamRecording">
      {!token && (
        <div className="IlosVideoEmbed--loading ta-c">
          <Spinner color="darker" />
          <span className="ml-16">{i18n.common.loading}</span>
        </div>
      )}
      {token && (
        <iframe
          title="Media Recording"
          src={`https://app.ilosvideos.com/webRTC/embed/${token}`}
          allowTransparency="true"
          allow="microphone camera encrypted-media"
          frameBorder="0"
        />
      )}
      {errorMessage && (
        <div className="ErrorContainer ErrorContainer--brandRed d-f ai-c mb-0 pos-r">
          <Icon name="warning_sign" className="mr-8" />
          <div>
            {i18n.video_response.error} {errorMessage}.{' '}
            {i18n.video_response.error_follow_up} {i18n.common.or}&nbsp;
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
            <div className="d-ib td-u c-p" onClick={unloadWebcam}>
              {i18n.video_response.try_again}
            </div>
            .
          </div>
        </div>
      )}
      {recording && !errorMessage && (
        <div className="pos-r d-f fz-bigger c-brand-gray-dark mt-8">
          <button
            type="button"
            className="NewButton NewButton--flat VideoResponseQuestion-transparentButton VideoResponseQuestion-cancelButton ml-a d-f ai-c"
            onClick={unloadWebcam}
          >
            <Icon className="mr-4" name="camera_off" />
            {i18n.webcam_recording.turn_off}
          </button>
        </div>
      )}
    </div>
  );
};

export default IlosRecording;
